import * as yup from 'yup';

export const validationSchema = yup.object({
	productTypeName: yup.string().required('Product Type Name is required'),
	productTypeDescription: yup.string().required('Product Type Description is required'),
});
